import React from "react";
import Page from "../components/Page";

const Docs = () => <Page title="Documentation">this is the Docs</Page>;

export default Docs;
